import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import moment from 'moment-timezone';

import { actions } from './redux/actions';
import '../Widgets.scss';
import Strings from '../../../../Strings';
import { hasPermission, PERMISSIONS } from '../../../../utils/userPermissions';

export const PatientsWithNoReadingsMetadata = {
  id: "PatientsWithNoReadingsWidget",
  name: Strings.widgets.patientsWithNoReadings,
  permission: '',
  defProps: { i: "PatientsWithNoReadingsWidget", w: 4, h: 2, minW: 2, minH: 2 },
  configuration: {
    days: {
      type: 'number',
      name: 'days',
      label: Strings.numberOfDays,
      min: 1,
      max: 30,
      defaultValue: 7,
      isRequired: true,
    },
    // We're not allowing to change widget title (yet). It would cause problems with dashboard filters.
    // title: {
    //   type: 'string',
    //   name: 'title',
    //   label: Strings.title,
    //   defaultValue: Strings.widgets.patientsWithNoReadings,
    //   isRequired: true,
    // },
  },
};

function PatientsWithNoReadings(props) {
  const { orgIds, days, getData, refreshTimestamp } = props;
  React.useEffect(() => {
    getData(
      moment()
        .subtract(days, 'day')
        .startOf('day')
        .format(),
      orgIds && orgIds.length > 0 ? orgIds : undefined,
    );
  }, [days, orgIds, refreshTimestamp]);

  const { isLoading, patientsWithNoReadings } = props;
  const canNavigate = hasPermission(PERMISSIONS.CARE_MANAGEMENT_PATIENT_LIST);

  return !isLoading && (
    <div className="boxWithVl-box">
      <div className="boxWithVl-valueBox black">{patientsWithNoReadings}</div>
      <div
        onClick={canNavigate ? () => props.onClick(`/cap-patients/list?filters=["NoReadingsSince:${days}"]`) : undefined}
        className={`boxWithVl-labelBox ${canNavigate ? 'clickable' : ''}`}
        data-tooltip-content={Strings.formatString(Strings.widgetsTooltips.inTheLastXDays, days)}
        data-tooltip-id="tooltip"
      >
        {Strings.formatString(Strings.widgets.patientsWithNoReadingsInTheLastDays, days)}
      </div>
    </div>
  )
}

PatientsWithNoReadings.propTypes = {
  getData: PropTypes.func,
  patientsWithNoReadings: PropTypes.any,
  isLoading: PropTypes.any,
  onClick: PropTypes.func,
  dashboardId: PropTypes.string,
  days: PropTypes.number,
  orgIds: PropTypes.arrayOf(PropTypes.string),
  refreshTimestamp: PropTypes.number,
};

const mapStateToProps = state => {
  const { widgetPatientsWithNoReadingsReducer } = state.dashboardWidgets;

  return {
    patientsWithNoReadings:
      widgetPatientsWithNoReadingsReducer && widgetPatientsWithNoReadingsReducer?.patientsWithNoReadings,
    isLoading: widgetPatientsWithNoReadingsReducer && widgetPatientsWithNoReadingsReducer?.isLoading,
    orgIds: state.entities?.orgFilter?.orgIds,
  };
};

const mapDispatchToProps = dispatch => ({
  getData: (days, orgId) => dispatch(actions.getPatientsWithNoReadings(days, orgId)),
  onClick: path => dispatch(push(path)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PatientsWithNoReadings);
